var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _linearGradient7, _circle, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8BankCardDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GoxropzxDjmhW8_IKrijXa",
    x1: 20.375,
    x2: 28.748,
    y1: -466.939,
    y2: -437.054,
    gradientTransform: "translate(0 478)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#GoxropzxDjmhW8_IKrijXa)",
    d: "M43.125,9H4.875C3.287,9,2,10.287,2,11.875v24.25C2,37.713,3.287,39,4.875,39h38.25 C44.713,39,46,37.713,46,36.125v-24.25C46,10.287,44.713,9,43.125,9z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GoxropzxDjmhW8_IKrijXb",
    x1: 149.391,
    x2: 151.301,
    y1: 83.814,
    y2: 88.441,
    gradientTransform: "rotate(-90 48 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5bc8ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42befc"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#GoxropzxDjmhW8_IKrijXb)",
    d: "M11,24L11,24c0,0.552-0.448,1-1,1H6c-0.552,0-1-0.448-1-1l0,0c0-0.552,0.448-1,1-1h4 C10.552,23,11,23.448,11,24z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GoxropzxDjmhW8_IKrijXc",
    x1: 149.391,
    x2: 151.301,
    y1: 91.814,
    y2: 96.441,
    gradientTransform: "rotate(-90 48 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5bc8ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42befc"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#GoxropzxDjmhW8_IKrijXc)",
    d: "M19,24L19,24c0,0.552-0.448,1-1,1h-4c-0.552,0-1-0.448-1-1l0,0c0-0.552,0.448-1,1-1h4 C18.552,23,19,23.448,19,24z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GoxropzxDjmhW8_IKrijXd",
    x1: 149.391,
    x2: 151.301,
    y1: 99.814,
    y2: 104.441,
    gradientTransform: "rotate(-90 48 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5bc8ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42befc"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#GoxropzxDjmhW8_IKrijXd)",
    d: "M27,24L27,24c0,0.552-0.448,1-1,1h-4c-0.552,0-1-0.448-1-1l0,0c0-0.552,0.448-1,1-1h4 C26.552,23,27,23.448,27,24z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GoxropzxDjmhW8_IKrijXe",
    x1: 149.391,
    x2: 151.301,
    y1: 107.814,
    y2: 112.441,
    gradientTransform: "rotate(-90 48 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5bc8ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42befc"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#GoxropzxDjmhW8_IKrijXe)",
    d: "M35,24L35,24c0,0.552-0.448,1-1,1h-4c-0.552,0-1-0.448-1-1l0,0c0-0.552,0.448-1,1-1h4 C34.552,23,35,23.448,35,24z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GoxropzxDjmhW8_IKrijXf",
    x1: 149.391,
    x2: 151.301,
    y1: 115.814,
    y2: 120.441,
    gradientTransform: "rotate(-90 48 126.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5bc8ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42befc"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#GoxropzxDjmhW8_IKrijXf)",
    d: "M43,24L43,24c0,0.552-0.448,1-1,1h-4c-0.552,0-1-0.448-1-1l0,0c0-0.552,0.448-1,1-1h4 C42.552,23,43,23.448,43,24z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#bbd2de",
    d: "M36.013,20h5.974C42.546,20,43,19.546,43,18.987v-4.974C43,13.454,42.546,13,41.987,13h-5.974 C35.454,13,35,13.454,35,14.013v4.974C35,19.546,35.454,20,36.013,20z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M13.5,31h-8C5.224,31,5,30.776,5,30.5v-1C5,29.224,5.224,29,5.5,29h8c0.276,0,0.5,0.224,0.5,0.5v1 C14,30.776,13.776,31,13.5,31z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M24.5,31h-8c-0.276,0-0.5-0.224-0.5-0.5v-1c0-0.276,0.224-0.5,0.5-0.5h8c0.276,0,0.5,0.224,0.5,0.5v1 C25,30.776,24.776,31,24.5,31z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M19.5,35h-14C5.224,35,5,34.776,5,34.5v-1C5,33.224,5.224,33,5.5,33h14c0.276,0,0.5,0.224,0.5,0.5v1 C20,34.776,19.776,35,19.5,35z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M46,30.474C43.992,28.341,41.153,27,38,27c-6.065,0-11,4.935-11,11c0,0.338,0.021,0.67,0.051,1 h16.074C44.713,39,46,37.713,46,36.125V30.474z",
    opacity: 0.05
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46,31.216c-1.927-2.269-4.796-3.716-8-3.716c-5.79,0-10.5,4.71-10.5,10.5 c0,0.338,0.019,0.671,0.051,1h15.574C44.713,39,46,37.713,46,36.125V31.216z",
    opacity: 0.07
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "GoxropzxDjmhW8_IKrijXg",
    x1: 28,
    x2: 48,
    y1: 80,
    y2: 80,
    gradientTransform: "matrix(1 0 0 -1 0 118)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21ad64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088242"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 10,
    fill: "url(#GoxropzxDjmhW8_IKrijXg)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.75,46.002c-0.689,0-1.25-0.561-1.25-1.25v-0.396c-0.724-0.129-1.449-0.337-2.043-0.589 c-0.583-0.25-0.958-0.816-0.958-1.443v-1.191c0-0.73,0.593-1.325,1.322-1.325c0.206,0,0.413,0.05,0.598,0.144 c0.301,0.154,1.37,0.653,2.581,0.653c0.522,0,0.644-0.113,0.645-0.115c-0.098-0.199-0.966-0.521-1.383-0.675 c-1.567-0.58-3.937-1.457-3.937-4.315c0-1.966,1.178-3.404,3.174-3.915V31.25c0-0.689,0.561-1.25,1.25-1.25h0.5 c0.689,0,1.25,0.561,1.25,1.25v0.222c0.593,0.068,1.093,0.184,1.52,0.35C41.25,31.913,42,32.293,42,33.396v1.047 c0,0.729-0.594,1.322-1.324,1.322c-0.197,0-0.389-0.043-0.569-0.128c-0.382-0.179-1.165-0.48-2.107-0.48 c-0.237,0-0.638,0.036-0.638,0.168c0,0.24,0.976,0.619,1.5,0.822c1.52,0.591,3.813,1.482,3.813,4.2c0,1.514-0.841,3.408-3.174,3.982 v0.422c0,0.689-0.561,1.25-1.25,1.25H37.75z",
    opacity: 0.05
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.75,45.502c-0.413,0-0.75-0.336-0.75-0.75v-0.824c-0.814-0.109-1.665-0.332-2.348-0.622 c-0.397-0.17-0.653-0.556-0.653-0.982v-1.191c0-0.455,0.369-0.825,0.822-0.825c0.128,0,0.257,0.031,0.371,0.089 c0.325,0.167,1.483,0.708,2.808,0.708c1.138,0,1.138-0.472,1.138-0.65c0-0.446-0.643-0.716-1.702-1.109 c-1.523-0.564-3.61-1.337-3.61-3.847c0-2.172,1.565-3.218,3.174-3.513V31.25c0-0.414,0.337-0.75,0.75-0.75h0.5 c0.413,0,0.75,0.336,0.75,0.75v0.678c0.75,0.053,1.354,0.172,1.838,0.36c0.2,0.079,0.663,0.342,0.663,1.108v1.047 c0,0.453-0.37,0.822-0.824,0.822c-0.124,0-0.243-0.027-0.356-0.081c-0.42-0.197-1.28-0.527-2.32-0.527 c-0.755,0-1.138,0.225-1.138,0.668c0,0.543,0.688,0.849,1.819,1.289c1.474,0.573,3.493,1.357,3.493,3.734 c0,1.444-0.842,3.187-3.174,3.575v0.83c0,0.414-0.337,0.75-0.75,0.75H37.75z",
    opacity: 0.05
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.674,40.347c0-3.599-5.313-2.896-5.313-5.022c0-1.11,1.248-1.169,1.638-1.169 c0.938,0,1.843,0.252,2.533,0.575C40.75,34.834,41,34.683,41,34.443v-1.047c0-0.351-0.132-0.559-0.343-0.642 c-0.473-0.184-1.152-0.319-2.157-0.352V31.25c0-0.138-0.112-0.25-0.25-0.25h-0.5c-0.138,0-0.25,0.112-0.25,0.25v1.171 c-1.559,0.152-3.174,1.032-3.174,3.078c0,3.731,5.313,2.99,5.313,4.955c0,0.618-0.395,1.15-1.638,1.15 c-1.25,0-2.399-0.436-3.034-0.762c-0.214-0.109-0.466,0.049-0.466,0.289v1.192c0,0.228,0.138,0.432,0.349,0.522 c0.753,0.32,1.763,0.562,2.652,0.633v1.273c0,0.138,0.112,0.25,0.25,0.25h0.5c0.138,0,0.25-0.112,0.25-0.25v-1.271 C40.832,43.286,41.674,41.725,41.674,40.347z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8BankCardDollar);
export default __webpack_public_path__ + "static/media/icons8-bank-card-dollar.430631626ef1260410016cf2482b9fe4.svg";
export { ForwardRef as ReactComponent };